var searchModule = angular.module('search', ['common', 'quote']);